// --- Dependencies -------------------------------------------------------------------------------
import type { ReactNode } from "react";
import { Navigate } from "react-router-dom";
// --- Our Modules --------------------------------------------------------------------------------
import usePermission from "@/hooks/usePermission";

// --- Types --------------------------------------------------------------------------------------

type Props = {
    /** An `ADMIN_PERMISSION_MODELS` entry. */
    model: string;
    children: ReactNode;
};

// --- Logic --------------------------------------------------------------------------------------

/**
 * Keeps a hidden tab from being reachable by typing its URL. This is convenience, not security —
 * the API re-checks the same permission on every request and is the only thing standing between an
 * admin and data they should not see.
 */
export default function PermissionGate({ model, children }: Props) {
    const { canView } = usePermission();

    if (!canView(model)) return <Navigate to="/" replace />;

    return <>{children}</>;
}
